import groupHeight from './GrouponHeight';

export default groupHeight;
